var React = require('react');

function Document (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M511.2,4.5v148.4c0,27.3,19.7,49.5,43.9,49.5h154L511.2,4.5z M560.6,251.9c-54.6,0-98.9-44.3-98.9-98.9V4.5H65.9v791.3l0,0\n\tc0,0.1,0,0.2,0,0.2c0,27.3,22.2,49.5,49.5,49.5h593.6V251.9L560.6,251.9L560.6,251.9z"}));
}

Document.defaultProps = {"version":"1.1","id":"Warstwa_1","x":"0px","y":"0px","viewBox":"0 0 775 850","style":{"enableBackground":"new 0 0 775 850"},"xmlSpace":"preserve"};

module.exports = Document;

Document.default = Document;
